import { Injectable, computed, inject } from '@angular/core';
import { AuthService, type TenantAuthUser } from './auth.service';

export type { TenantAuthUser };

/** Tenant portal session — backed by unified AuthService. */
@Injectable({ providedIn: 'root' })
export class TenantAuthService {
  private readonly authService = inject(AuthService);

  readonly loading = this.authService.loading;

  readonly currentUser = computed(() => this.authService.getTenantUser());

  async restoreSession(): Promise<boolean> {
    const ok = await this.authService.restoreSession();
    return ok && this.authService.isTenantSession();
  }

  async logout(): Promise<void> {
    await this.authService.logout();
  }

  getAccessToken(): string | null {
    return this.authService.getAccessToken();
  }

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated() && this.authService.isTenantSession();
  }

  clearSession(): void {
    this.authService.clearSession();
  }
}
